"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMenuProps = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl/FormControl.js"));
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel/InputLabel.js"));
var _Select = _interopRequireDefault(require("@mui/material/Select/Select.js"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Select2 = require("./Select.styles");
var _Typography = _interopRequireDefault(require("../Typography"));
var _Colors = _interopRequireDefault(require("../../styles/Colors"));
var _ChevronDownIcon = _interopRequireDefault(require("../../assets/Icons/ChevronDownIcon"));
var _Input = require("../Input");
var _useComputedColor2 = require("../../hooks/useComputedColor");
var _Menu = require("../Menu");
var _useTransformUnitUtils = require("../../hooks/useTransformUnitUtils");
var _CommonSerializedStyles = require("../../internals/styles/CommonSerializedStyles");
var _excluded = ["label", "error", "hint", "helperText", "disabled", "readOnly", "selectOptions", "value", "children", "required", "margin", "width", "height", "color", "multiple", "className", "sx", "HintProps", "componentsProps"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SelectFormControl = (0, _styled.default)(_FormControl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n"])), _Input.inputBaseStyles, _Select2.selectBaseStyles, _CommonSerializedStyles.MuiBoxSizingWildcard);
var selectMenuProps = {
  PaperProps: {
    component: _Menu.MenuPaper,
    variant: 'none',
    sx: {
      borderRadius: '8px'
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  },

  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  }
};
exports.selectMenuProps = selectMenuProps;
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var label = props.label,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    hint = props.hint,
    helperText = props.helperText,
    disabled = props.disabled,
    readOnly = props.readOnly,
    selectOptions = props.selectOptions,
    value = props.value,
    children = props.children,
    required = props.required,
    margin = props.margin,
    _props$width = props.width,
    width = _props$width === void 0 ? '100%' : _props$width,
    height = props.height,
    color = props.color,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    sx = props.sx,
    HintProps = props.HintProps,
    componentsProps = props.componentsProps,
    rest = _objectWithoutProperties(props, _excluded);
  var _useTransformUnitUtil = (0, _useTransformUnitUtils.useTransformUnitUtils)(),
    transformUnitProps = _useTransformUnitUtil.transformUnitProps;
  var _useComputedColor = (0, _useComputedColor2.useComputedColor)({
      color: error ? 'error' : color,
      defaultColor: 'primary'
    }),
    mainColor = _useComputedColor.computedColor;
  var labelColor = (0, _react.useMemo)(function () {
    if (disabled) {
      return 'lightGrey';
    }
    if (error) {
      return 'error';
    }
    return 'grey';
  }, [disabled, error]);
  var variablesSx = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, transformUnitProps({
      '--width': width !== null && width !== void 0 ? width : sx === null || sx === void 0 ? void 0 : sx.width,
      '--height': height !== null && height !== void 0 ? height : sx === null || sx === void 0 ? void 0 : sx.height,
      '--margin': margin !== null && margin !== void 0 ? margin : sx === null || sx === void 0 ? void 0 : sx.margin
    })), {}, {
      '--colors-main': mainColor,
      '--colors-mainLight': "".concat(mainColor, "40")
    });
  }, [transformUnitProps, width, sx, height, margin, mainColor]);
  var getInputValueToShow = (0, _react.useCallback)(function () {
    var _selectOptions$find$l, _selectOptions$find;
    if (Array.isArray(value)) {
      var _selectOptions$reduce, _selectOptions$reduce2;
      return (_selectOptions$reduce = selectOptions === null || selectOptions === void 0 ? void 0 : (_selectOptions$reduce2 = selectOptions.reduce(function (acc, option) {
        if (value.includes(option === null || option === void 0 ? void 0 : option.value)) {
          acc.push("".concat(option.label));
        }
        return acc;
      }, [])) === null || _selectOptions$reduce2 === void 0 ? void 0 : _selectOptions$reduce2.join(', ')) !== null && _selectOptions$reduce !== void 0 ? _selectOptions$reduce : '';
    }
    return "".concat((_selectOptions$find$l = selectOptions === null || selectOptions === void 0 ? void 0 : (_selectOptions$find = selectOptions.find(function (option) {
      return (option === null || option === void 0 ? void 0 : option.value) === value;
    })) === null || _selectOptions$find === void 0 ? void 0 : _selectOptions$find.label) !== null && _selectOptions$find$l !== void 0 ? _selectOptions$find$l : '');
  }, [selectOptions, value]);
  var getOption = function getOption(option) {
    return /*#__PURE__*/_react.default.createElement(_Menu.MenuItem, _extends({
      key: option === null || option === void 0 ? void 0 : option.value,
      value: option === null || option === void 0 ? void 0 : option.value,
      label: option.label,
      selected: Array.isArray(value) && (value === null || value === void 0 ? void 0 : value.includes(option === null || option === void 0 ? void 0 : option.value)) || value === (option === null || option === void 0 ? void 0 : option.value)
    }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.menuItem));
  };
  var hintOrHelperText = hint || helperText;
  return /*#__PURE__*/_react.default.createElement(SelectFormControl, _extends({
    ref: ref,
    variant: "filled",
    error: error,
    disabled: disabled,
    sx: _objectSpread(_objectSpread({}, variablesSx), sx),
    className: "".concat(className, " ").concat(!label ? '--no-label' : '', " ").concat(HintProps !== null && HintProps !== void 0 && HintProps.hidden ? '--no-hint' : '')
  }, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.formControl), label && /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({}, componentsProps === null || componentsProps === void 0 ? void 0 : componentsProps.labelTypography, {
    variant: "body",
    color: labelColor,
    component: _InputLabel.default
  }), label, " ", required ? '*' : ''), /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    error: error,
    disabled: disabled,
    readOnly: readOnly,
    IconComponent: function IconComponent(iconProps) {
      return /*#__PURE__*/_react.default.createElement(_ChevronDownIcon.default, _extends({
        width: "12",
        height: "12",
        fill: error ? mainColor : _Colors.default.textElementGrey
      }, iconProps));
    },
    multiple: multiple,
    value: value,
    renderValue: getInputValueToShow,
    MenuProps: selectMenuProps,
    componentsProps: componentsProps
  }, rest, {
    variant: "filled"
  }), children !== null && children !== void 0 ? children : selectOptions && selectOptions.map(getOption)), (!!hintOrHelperText || (HintProps === null || HintProps === void 0 ? void 0 : HintProps.forceVisibility)) && /*#__PURE__*/_react.default.createElement(_Input.InputHint, _extends({
    title: hintOrHelperText !== null && hintOrHelperText !== void 0 ? hintOrHelperText : '',
    error: error,
    color: labelColor
  }, HintProps)));
});
var _default = Select;
exports.default = _default;